import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const NormalDiv = styled.div`
    height: ${(props) => props.height};
    display: flex;
    align-items: center;
    padding: 0;
    margin: ${({ margin }) => (margin ? margin : 0)};

    @media only screen and (max-device-width: 360px) {
        width: ${({ isContentHeaderFooter }) =>
            isContentHeaderFooter && '100%'};
    }
`;
export const RegularText = styled.div`
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    margin: ${({ margin }) => (margin ? margin : 0)};
    line-height: ${({ lineHeight }) => lineHeight};
`;

export const OrderTypeIcon = styled.div`
    margin: 0;
    padding: 0.9rem 0px 0.9rem 8px;
    /* width: calc(40% - 20px); */
    ${({ week }) =>
        week &&
        `
        display: none;
        `}

    & img {
        width: ${(props) => props.width};
        height: 40px;
    }

    ${media.smalDevice`
        width: cal(20%-20px);
        & img{
            width: auto;
            height: auto;
        }
    `}

    ${media.exSmallDevice`
        display: none ;
    `}
`;

export const IconDetailsContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: 100%;

    ${({ week }) =>
        week &&
        `
            min-height: 230px;
            padding:0;
            margin:0;
            overflow:hidden;
        `}

    ${media.mobileDevice`
        margin-left:5px;
    `}

    ${media.exSmallDevice`
        margin-left: auto;
    `}
`;
export const OrderLeftColorCode = styled.div`
    border-left: 5px solid;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${(props) => props.orderStatusColor.backgroundColor};
    border-color: ${(props) => props.orderStatusColor.borderColor};
`;

export const OrderContentContainer = styled.div`
    margin: 0;
    width: cal(100%-20px);
    padding: 12px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    letter-spacing: 0px;
    font-family: AvenirNextWorld Regular;

    ${media.largeDevice`
        justify-content: space-between ;
    `}
`;

export const DetailsContianer = styled.div`
    display: flex;
    text-align: left;
    flex-direction: column;
    flex-wrap: wrap;
    width: 70%;
    flex-grow: 1;
    margin: 0.9rem;
    font-family: AvenirNextWorld Regular;
    ${({ week }) =>
        week &&
        `
            width: 100%;
            margin: 0;
            padding: 11px 16px 11px 14px;
        `}
    & .title {
        font-family: AvenirNextWorld Demi;
        width: 100%;
        color: #140f4b;
        display: flex;
        justify-content: space-between;
        align-items: center;
        ${({ week }) =>
            week &&
            `
            display: flex;
            flex-direction: column-reverse;
            justify-content: flex-start;
            align-items:  flex-start;
            font-size: 12px;
            `}

        ${media.exSmallDevice`
            display: flex;
            flex-direction: column-reverse;
            justify-content: flex-start;
            align-items: left;
        `}
    }

    & .title > .time {
        font-family: AvenirNextWorld Regular;
        text-align: right;
        font-size: 10px;
        color: #000000;
        float: right;
        margin: 0.2rem;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        ${({ week }) =>
            week &&
            `
            text-align: left;
            margin:0;
            `}

        ${media.exSmallDevice`
            text-align: left;
        `}
    }

    & .details {
        color: #140f4b;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        ${({ week }) =>
            week &&
            `
            font-size: 11px;
            white-space: pre-wrap;
            `}
    }

    & .refernce-number {
        color: #1010eb;
        font-size: 12px;
        ${({ week }) =>
            week &&
            `
            margin: 10px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-wrap:break-word;
            font-size: 11px;
            `}
    }

    & .setCount{
        font-family: AvenirNextWorld Regular;
        float: right;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #707070;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        min-width: 50px;
        white-space: nowrap;
        height: 22px;
        color:#000000;
        display: ${(props) => props.isSetsVisible};

        ${({ week }) =>
            week &&
            `
            margin-bottom:10px;
            font-size: 10px;
            width: 44px;
            height: 18px;
            `}

        ${media.exSmallDevice`
            width: 3.5rem;
        `}
    }
    }
    & .footer {
        font-family: AvenirNextWorld Demi;
        color: #3c3c3c;
        opacity: 1;
        font-size: 14px;
        margin-top: 15px;

        ${({ week }) =>
            week &&
            `
            display: flex;
            flex-direction: column-reverse;
            justify-content: flex-start;
            align-items: left;
            font-size: 12px;
            `}

        ${media.exSmallDevice`
            display: flex;
            flex-direction: column-reverse;
            justify-content: flex-start;
            align-items: left;
        `}
    }

    & .footer > .set {
        font-family: AvenirNextWorld Regular;
        float: right;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #707070;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        width: 50px;
        height: 22px;
        display: ${(props) => props.isSetsVisible};

        ${({ week }) =>
            week &&
            `
            margin-bottom:10px;
            font-size: 10px;
            width: 44px;
            height: 18px;
            `}

        ${media.exSmallDevice`
            width: 3.5rem;
        `}
    }
`;
export const AccountDiv = styled.div`
    display: flex;
    font-size: 14px;
    min-width: 0;
    width: 100%;

    ${media.exSmallDevice`
        flex-direction: column;
        width: 100%;
    `}

    ${({ week }) =>
        week &&
        `
        font-size: 11px;
        flex-direction: column;
        width: 100%;
    `}
`;

export const AccountNameTrunc = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    /* max-width: 185px; */
    font-family: ${(props) => {
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular';
    }};
    font-size: ${(props) => {
        props.fontSize ? props.fontSize : '14px';
    }};
    color: #140f4b;
    ${({ week }) =>
        week &&
        `
        font-size: 11px;
        width: 100%;
    `}

    ${media.mediumDevice`
    /* max-width: 210px; */
    ${({ week }) =>
        week &&
        `
        width: 100%;
    `}
    `}

    ${media.smalDevice`
     /* max-width: 185px; */
     ${({ week }) =>
         week &&
         `
        width: 100%;
    `}
    `}
    
    ${media.mobileDevice`
        /* max-width: 210px; */
    `}

    ${media.exSmallDevice`
        width: 100%;
    `}
`;

export const AccountNumber = styled.div`
    padding: 0 0.2rem 0 5px;
    flex-shrink: 0;
    font-family: AvenirNextWorld Italic;
    color: #140f4b;
    ${({ week }) =>
        week &&
        `
        padding: 0;
        font-family: AvenirNextWorld Regular;        
    `}
    ${media.exSmallDevice`
        padding: 0;
    `}
`;
export const MyCaseRefNumber = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    ${({ week }) =>
        week &&
        ` flex-direction: column;
         font-size: 12px;         
    `}
`;
